import retryCallIfNeeded from '../../../restCalls';

const walletEndpoint = '/api/wallet/v1';
export default function walletService(client) {
  // ###
  // SSN
  // ###
  const getSsnByPersonIdAsync = async personId => retryCallIfNeeded(client, () => client
    .get(`${walletEndpoint}/wallets/?personId=${personId}`));
  const deleteSsnByPersonIdAsync = async personId => retryCallIfNeeded(client, () => client
    .delete(`${walletEndpoint}/wallets/?personId=${personId}`));
  const postSsnByPersonIdAsync = async (ssn, personId) => {
    const payload = { ssn, personId };
    return retryCallIfNeeded(client, () => client
      .post(`${walletEndpoint}/wallets`, payload));
  };
  const putSsnByPersonIdAsync = async (ssn, personId) => {
    const payload = { ssn, personId };
    return retryCallIfNeeded(client, () => client
      .put(`${walletEndpoint}/wallets`, payload));
  };
  const getFullSsnByPersonIdAsync = async personId => retryCallIfNeeded(client, () => client
    .get(`${walletEndpoint}/wallets?digits=9&personId=${personId}`));

  const getPersonIdsbySsn = async payload => retryCallIfNeeded(client, () => client.post(`${walletEndpoint}/wallets/search`, payload));

  return {
    // SSN
    getSsnByPersonIdAsync,
    postSsnByPersonIdAsync,
    putSsnByPersonIdAsync,
    deleteSsnByPersonIdAsync,
    getFullSsnByPersonIdAsync,
    getPersonIdsbySsn,
  };
}
